import { createMigration } from './utils';

/**
 * Moves the `animateOutBehaviour` from the normalStyle into the text asset.
 */
export const migrationTo9_157 = createMigration({
    migrateVideo(video) {
        return video.withMutations(map => {
            map.get('slides').forEach((scene, i) => {
                map.setIn(['slides', i], this.migrateScene(scene));
            });
        });
    },

    migrateScene(scene) {
        return scene.withMutations(map => {
            const moveAnimateOutBehaviourToTextAsset = (map, path) => {
                if (map.hasIn([...path, 'normalStyle', 'animateOutBehaviour'])) {
                    map.setIn([...path, 'animateOutBehaviour'], map.getIn([...path, 'normalStyle', 'animateOutBehaviour']));
                }
            };

            map.get('children', []).forEach((child, c) => {
                const path = ['children', c];
                if (map.getIn([...path, 'classType']) !== 'GraphicStyleTextAsset') {
                    return;
                }
                moveAnimateOutBehaviourToTextAsset(map, path);
            });

            map.get('subslides', []).forEach((subslide, s) => {
                subslide.get('children', []).forEach((child, c) => {
                    const path = ['subslides', s, 'children', c];
                    if (map.getIn([...path, 'classType']) !== 'GraphicStyleTextAsset') {
                        return;
                    }

                    moveAnimateOutBehaviourToTextAsset(map, path);
                });
            });
        });
    },
});

